import React, { useEffect, useContext, useState } from 'react'
import { Grid, Typography, Paper, Container, useMediaQuery, Box, Button, CssBaseline } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Sidebar from '../components/Sidebar';
import { useTheme, styled } from '@mui/material/styles';
import { useAuth } from '../context/AuthContext'
import FlowChart from '../components/FlowChart';
import Widget from '../components/Widget';
import SidebarContent from '../components/SidebarComponent';
import axios from 'axios'
import GoogleIcon from '@mui/icons-material/Google';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';


const BizzFlow = () => {
  const [accessToken, setTokens] = useState('');
  const [urlTok, setUrlTok] = useState(null)
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedWidget, setSelectedWidget] = useState(null);
  const [sheetData, setSheetData] = useState(null);
  const [transformData, setTransformData] = useState(null);
  const [modelInputData, setModelInputData] = useState(null);
  const [visualizationData, setVisualizationData] = useState(null);
  const [nodeId, setNodeId] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth()


  const updateNodeWithSourceData = (data, id) => {
    setSheetData(data);
    setNodeId(id);
  };

  const updateTransformNodeData = (nodeId, newData) => {

    setTransformData(newData)
    setNodeId(nodeId)

  };
  const retrieveToken = async (userId) => {
    try {
      const email=JSON.parse(userId).email
          console.log(email)
          const response = await axios.get(`${process.env.REACT_APP_BACK_END_URL}/gsheets/retrieve-token`, { params: { user_id: email } });
      const { token } = response.data;
      localStorage.setItem('googleToken', token);  // Store the token in localStorage
    } catch (error) {
      console.error("Error retrieving token:", error);
    }
  };
  useEffect(() => {
    const checkAuthenticationAndGetToken = async () => {
      // Assuming you have some way to check if the user is authenticated
      if (user) {
        try {
          const userId = localStorage.getItem('user')
          const email=JSON.parse(userId).email
          console.log(email)
          const response = await axios.get(`${process.env.REACT_APP_BACK_END_URL}/gsheets/retrieve-token`, { params: { user_id: email } });
          const { token } = response.data;
          localStorage.setItem('googleToken', token);
          // Now you have the token, and you can proceed with your application logic
        } catch (error) {
          console.error('Error retrieving token:', error);
          // Handle error appropriately
        }
      }
    };

    checkAuthenticationAndGetToken();
  }, []);

  const updateVisualizeData = (nodeId, visualization_data) => {
    setVisualizationData(visualization_data)
    setNodeId(nodeId)
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const urlToken = queryParams.get('access_token');


    // Save the urlToken to sessionStorage
    console.log(urlToken)
    sessionStorage.setItem('urlToken', urlToken);
    console.log("Session Storage Token:", sessionStorage.getItem('urlToken'));
    setUrlTok(urlToken)

  }, [accessToken, navigate, location, setTokens]);



  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const connectToGoogle = async () => {

    // Fetch the Google Auth URL from our backend
    const response = await axios.get(`${process.env.REACT_APP_BACK_END_URL}/gsheets/auth/login`);
    const { url } = response.data;

    // Redirect the user to the Google Auth Page
    window.location.href = url;
    console.log(localStorage.getItem('user'))
    retrieveToken(localStorage.getItem('user'));
  };

  const toggleSidebar = (forceClose = false) => {
    if (forceClose) {
      setIsSidebarOpen(false);
    } else {
      setIsSidebarOpen(!isSidebarOpen);
    }
  };



  return (
    <DndProvider backend={HTML5Backend}>
      <div style={{ background: theme.palette.background.default, height: '100vh' }}>

        <CssBaseline />
        <Navbar />
        <Grid container style={{ height: 'calc(100vh - 64px)' }}> {/* Adjusted height */}
          {!isSmallScreen && (

            <Grid item xs={2} style={{ height: '100%' }}>
              <Sidebar />
            </Grid>

          )}
          <Grid item xs={12} sm={10} style={{ height: '100%', padding: '8px', overflowY: 'auto', background: theme.palette.white[100], display: 'flex', flexDirection: 'row' }}>
            {/* Flowchart */}

            <div style={{ flex: 6, background: theme.palette.white[100], marginRight: "5px" }}>

              <FlowChart
                toggleSidebar={toggleSidebar}
                setSelectedWidget={setSelectedWidget}
                sheetData={sheetData}
                setTransformData={setTransformData}
                modelInputData={modelInputData}
                setModelInputData={setModelInputData}
                nodeId={nodeId}
                setNodeId={setNodeId}
                transformData={transformData}
                visualizationData={visualizationData}
                setVisualizationData={setVisualizationData} />

            </div>

            {isSidebarOpen && ( // Step 3: Conditionally render the sidebar based on isSidebarOpen
              <Paper
                elevation={2}
                style={{
                  flex: 2,
                  padding: '10px',
                  boxSizing: 'border-box',
                  overflow: 'auto',
                  background: theme.palette.black[400],
                  color: 'black',
                  display: 'flex',
                  flexDirection: 'column',
                  marginRight: '3px'
                }}
              >
                {/* Pass data from the dropped widget to the sidebar for configuration */}
                {/* You can add more props as needed */}

                <SidebarContent
                  selectedWidget={selectedWidget}
                  setSheetData={setSheetData}
                  sheetData={sheetData}
                  setTransformData={setTransformData}
                  transformData={transformData}
                  modelInputData={modelInputData}
                  nodeId={nodeId}
                  setNodeId={setNodeId}
                  updateNodeWithSourceData={updateNodeWithSourceData}
                  updateTransformNodeData={updateTransformNodeData}
                  visualizationData={visualizationData}
                  setVisualizationData={setVisualizationData}
                  toggleSidebar={toggleSidebar} />
              </Paper>

            )}
            {/* Right sidebar */}

            <Paper elevation={3} style={{ flex: 2, padding: '10px', boxSizing: 'border-box', overflow: 'auto', background: theme.palette.black[600], color: 'black', display: 'flex', flexDirection: 'column' }}>
              {!urlTok && (
                <Button onClick={connectToGoogle} style={{ color: 'black', backgroundColor: 'white' }}>
                  <GoogleIcon color='info' sx={{ color: 'blue', marginRight: '10px' }} /> <InsertDriveFileIcon color='success' style={{ marginRight: '10px' }} />Connect to Google Sheets
                </Button>)}
              {urlTok && (<>
                <Typography variant="h5" gutterBottom style={{ color: 'white' }}>Connectors</Typography>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                  <Widget type="DataSourceNode" name="Data Source" />
                  <Widget type="TransformationNode" name="Transform" />
                  <Widget type="ModelNode" name="Model" />
                  <Widget type="VisualizationNode" name="Visualization" />
                  {/* <Widget type="DecisionNode" name="Decision" /> */}

                </div>
              </>)}

            </Paper>

          </Grid>


        </Grid>

      </div>
    </DndProvider >
  );

}

export default BizzFlow